/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AiImage,
  AiImageRequestInput,
  DiscardAllAiImagesParams,
  ListAiImagesParams,
  PaginatedAiImages,
  SchemaValidationErrorResponse,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create AI Image
 */
export const createImage = (
    aiImageRequestInput: MaybeRefOrGetter<AiImageRequestInput>,
 signal?: AbortSignal
) => {
      aiImageRequestInput = toValue(aiImageRequestInput);

      return axiosClient<AiImage>(
      {url: `/ai/images`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiImageRequestInput, signal
    },
      );
    }




export const getCreateImageMutationKey = () => ['createImage'] as const;

export const getCreateImageMutationOptions = <TError = ErrorType<void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImage>>, TError,CreateImageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createImage>>, TError,CreateImageMutationVariables, TContext> => {

const mutationKey = getCreateImageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createImage>>, CreateImageMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createImage(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateImageMutationResult = NonNullable<Awaited<ReturnType<typeof createImage>>>
    export type CreateImageMutationBody = AiImageRequestInput
    export type CreateImageMutationError = ErrorType<void | ValidationError>
    export type CreateImageMutationVariables = {data: AiImageRequestInput}

    /**
 * @summary Create AI Image
 */
export const useCreateImage = <TError = ErrorType<void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImage>>, TError,CreateImageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createImage>>,
        TError,
        CreateImageMutationVariables,
        TContext
      > => {
      return useMutation(getCreateImageMutationOptions(options), queryClient);
    }
    /**
 * @summary List of AI Images
 */
export const listAiImages = (
    params?: MaybeRefOrGetter<ListAiImagesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedAiImages>(
      {url: `/ai/images`, method: 'GET',
        params, signal
    },
      );
    }




export const getListAiImagesQueryKey = (params?: MaybeRefOrGetter<ListAiImagesParams>,) => {
    return [
    'ai','images', ...(params ? [params] : [])
    ] as const;
    }


export const getListAiImagesQueryOptions = <TData = Awaited<ReturnType<typeof listAiImages>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListAiImagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiImages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiImagesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiImages>>> = ({ signal }) => listAiImages(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiImages>>, TError, TData>
}

export type ListAiImagesQueryResult = NonNullable<Awaited<ReturnType<typeof listAiImages>>>
export type ListAiImagesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of AI Images
 */

export function useListAiImages<TData = Awaited<ReturnType<typeof listAiImages>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListAiImagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiImages>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiImagesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Move all AI images of the current user to the trash
 */
export const discardAllAiImages = (
    params?: MaybeRefOrGetter<DiscardAllAiImagesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<void>(
      {url: `/ai/images/all`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDiscardAllAiImagesMutationKey = () => ['discardAllAiImages'] as const;

export const getDiscardAllAiImagesMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discardAllAiImages>>, TError,DiscardAllAiImagesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof discardAllAiImages>>, TError,DiscardAllAiImagesMutationVariables, TContext> => {

const mutationKey = getDiscardAllAiImagesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof discardAllAiImages>>, DiscardAllAiImagesMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  discardAllAiImages(params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiscardAllAiImagesMutationResult = NonNullable<Awaited<ReturnType<typeof discardAllAiImages>>>

    export type DiscardAllAiImagesMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DiscardAllAiImagesMutationVariables = {params?: DiscardAllAiImagesParams}

    /**
 * @summary Move all AI images of the current user to the trash
 */
export const useDiscardAllAiImages = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discardAllAiImages>>, TError,DiscardAllAiImagesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof discardAllAiImages>>,
        TError,
        DiscardAllAiImagesMutationVariables,
        TContext
      > => {
      return useMutation(getDiscardAllAiImagesMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete AI Assistant
 */
export const deleteAiImage = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/ai/images/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteAiImageMutationKey = () => ['deleteAiImage'] as const;

export const getDeleteAiImageMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiImage>>, TError,DeleteAiImageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiImage>>, TError,DeleteAiImageMutationVariables, TContext> => {

const mutationKey = getDeleteAiImageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiImage>>, DeleteAiImageMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteAiImage(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiImageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiImage>>>

    export type DeleteAiImageMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteAiImageMutationVariables = {id: string}

    /**
 * @summary Delete AI Assistant
 */
export const useDeleteAiImage = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiImage>>, TError,DeleteAiImageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiImage>>,
        TError,
        DeleteAiImageMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAiImageMutationOptions(options), queryClient);
    }
    /**
 * @summary AI Image Details
 */
export const getAiImage = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<AiImage>(
      {url: `/ai/images/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetAiImageQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'ai','images',id
    ] as const;
    }


export const getGetAiImageQueryOptions = <TData = Awaited<ReturnType<typeof getAiImage>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiImage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiImageQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiImage>>> = ({ signal }) => getAiImage(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiImage>>, TError, TData>
}

export type GetAiImageQueryResult = NonNullable<Awaited<ReturnType<typeof getAiImage>>>
export type GetAiImageQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary AI Image Details
 */

export function useGetAiImage<TData = Awaited<ReturnType<typeof getAiImage>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiImage>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiImageQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






